import { useEffect, useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useNavigate } from 'react-router-dom'

import Action from 'ageas-react-component-action'
import PolicyData from 'ageas-react-component-greybackground'
import Link from 'ageas-react-component-link'
import MiniLoader from 'ageas-react-component-miniloader'

import { EntityDetails } from '../../Components/OwnerData/EntityDetails'
import { OwnerIdentification } from '../../Components/OwnerData/OwnerIdentification'
import { MainContainer } from '../../GlobalStyles'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { useProgressStore } from '../../Stores/progressStore'
import { useCreatePolicyHolderEntityStore } from '../../Stores/useCreatePolicyholderEntityStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useResumeStore } from '../../Stores/useResumeStore'
import { ROUTES } from '../../constants/routes'
import { useSubmitPolicyholderData } from '../../hooks/api/submitPolicyholderData/useSubmitPolicyholderData'
import { useSubmitPolicyHolderDataPayload } from '../../hooks/api/submitPolicyholderData/useSubmitPolicyholderDataPayload'
import { useGetAdditionalEntityDetails } from '../../hooks/api/useGetAdditionalEntityDetails'
import { t } from '../../i18n'
import { Owner } from './Owner'
import { DataContainer } from './style'

const elementPortal = document.getElementsByTagName('body')?.[0]

export function OwnerData() {
  const navigate = useNavigate()
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { setCurrentStep } = useProgressStore()
  const [showEntityDetails, setShowEntityDetails] = useState(false)
  const [isRequestLoading, setIsRequestLoading] = useState(false)
  const [enableGetAdditional, setEnableGetAdditional] = useState(true)
  const { setIsPolicyholderCreated } = useCreatePolicyHolderEntityStore()
  const { disabledStepsByResume } = useResumeStore()
  const {
    mutate,
    isLoading,
    isError: isErrorGetAdditionalEntity,
  } = useGetAdditionalEntityDetails()
  const {
    mutate: submitPolicyHolderDataMutate,
    isSuccess: submitPolicyHolderDataIsSuccess,
    isLoading: submitPolicyHolderDataIsLoading,
  } = useSubmitPolicyholderData()

  const submitPolicyHolderDataPayload = useSubmitPolicyHolderDataPayload()
  const { isGenerateProposalDocuments } = useGenerateProposalDocumentsStore()

  useLayoutEffect(() => {
    setCurrentStep(3)
  }, [setCurrentStep])

  useEffect(() => {
    if (
      policyholderDetailsSelected &&
      enableGetAdditional &&
      !disabledStepsByResume.step3 &&
      !policyholderDetailsSelected.isProspect
    ) {
      mutate({ entityId: policyholderDetailsSelected?.idEntity || '' })
      setEnableGetAdditional(false)
    }
  }, [policyholderDetailsSelected, mutate, enableGetAdditional])

  useEffect(() => {
    if (submitPolicyHolderDataIsSuccess) {
      navigate(ROUTES.additionalRiskData)
    }
  }, [submitPolicyHolderDataIsSuccess])

  return (
    <MainContainer>
      <DataContainer>
        <PolicyData
          id="owner-data"
          version="2"
          name={t('pages.step3.title')}
          open={true}
          detail={true}
          components={
            <div className="container">
              {(policyholderDetailsSelected?.isProspect ||
                !policyholderDetailsSelected) && (
                <Owner setLoading={setIsRequestLoading} />
              )}
              {(isRequestLoading ||
                isLoading ||
                submitPolicyHolderDataIsLoading) && (
                <MiniLoader
                  color="transparent"
                  minHeight="auto"
                  maxWidth="auto"
                />
              )}
              {!isRequestLoading &&
                policyholderDetailsSelected &&
                !isLoading &&
                !submitPolicyHolderDataIsLoading &&
                !policyholderDetailsSelected.isProspect && (
                  <>
                    <OwnerIdentification />
                    {!isGenerateProposalDocuments &&
                      !disabledStepsByResume.step3 && (
                        <div className="button-create">
                          <Link
                            label={t('pages.step3.entityDetails')}
                            onValueChanged={() => {
                              setShowEntityDetails(true)
                              setIsPolicyholderCreated(false)
                            }}
                          />
                        </div>
                      )}
                  </>
                )}
            </div>
          }
        />
        {createPortal(
          <EntityDetails
            isVisible={showEntityDetails}
            closeAction={() => setShowEntityDetails(false)}
          />,
          elementPortal!,
        )}
        <div className="button-right">
          <Action
            id="navigateAction"
            label={t('general.continue')}
            type="button"
            disable={
              isRequestLoading ||
              isLoading ||
              isErrorGetAdditionalEntity ||
              !policyholderDetailsSelected ||
              policyholderDetailsSelected?.idExternalType === "PRO" ||
              submitPolicyHolderDataIsLoading ||
              isGenerateProposalDocuments ||
              disabledStepsByResume.step3
            }
            onValueChanged={() =>
              submitPolicyHolderDataMutate(submitPolicyHolderDataPayload)
            }
          />
        </div>
      </DataContainer>
    </MainContainer>
  )
}
